import { Component, h, Prop, Host } from '@stencil/core';
import { toValUnit } from './../../../utils/utils';

@Component({
  tag: 'afs-button',
  styleUrl: 'afs-button.sass',
  shadow: true,
})
export class AfsButton {

  @Prop() backgroundColor : string = "#222222";
  @Prop() borderColor : string;
  @Prop() color : string = "#FFFFFF";
  @Prop() roundedEdge : boolean = false;
  @Prop() href : string;
  @Prop() target : string;
  @Prop() size : 'xs' | 's' | 'm' | 'l' | 'lxl' | 'xl' | '2xl' = 'm';
  @Prop() sizeTablet :  'xs' | 's' | 'm' | 'l' | 'lxl' | 'xl' | '2xl';
  @Prop() thin : boolean = false;
  @Prop() disabled : boolean = false;
  @Prop() width : string;
  @Prop() widthTablet : string;

  render() {

    const buttonTemplate =  <button
                              style={{
                                backgroundColor: this.backgroundColor,
                                border: this.borderColor ? `2px solid ${this.borderColor}` : '',
                                color: this.color,
                                borderRadius: this.roundedEdge ? '1000rem' : '0.2rem',
                                fontSize: `var(--fs-${this.size})`,
                                '--tablet-font-size': this.sizeTablet ? `var(--fs-${this.sizeTablet})` : `var(--fs-${this.size})`,
                                padding: this.thin ? '0.2rem 1rem' : '0.4rem 1.8rem'
                              }}
                              data-disabled={this.disabled.toString()}
                            ><slot></slot></button>;

    return (
      <Host style={{
        width: this.width ? toValUnit(this.width) : 'fit-content', 
        '--width-tablet': this.widthTablet ? toValUnit(this.widthTablet) : this.width ? toValUnit(this.width) : 'fit-content',
      }}>
        {this.href ? <afs-link href={this.href} target={this.target} disabled={this.disabled}>{buttonTemplate}</afs-link> : buttonTemplate}
      </Host>
    )
  }

}
